import { getLocalPACSToken } from '@custom/Utils/authUtils';
import axios from 'axios';
import {
  FILTER_PATIENT_STUDIES,
  CREATE_REPORT_TEMPLATE,
  GET_ALL_PATIENT_API_URL,
  GET_ALL_REPORT_TEMPLATES,
  LOGIN_API_URL,
  CREATEUSER_API_URL,
  DELETE_REPORT_TEMPLATE,
  CREATE_REPORT,
  GET_ALL_REPORTS,
  UPDATE_REPORT,
  GET_CURRENT_PATIENT_REPORT,
  EDIT_REPORT_TEMPLATE,
  UPDATED_REPORT_DATA,
  CREATE_HOSPITAL,
  HOSPITAL_LIST,
  UPDATE_HOSPITAL_DETAIL,
  DELETE_HOSPITAL,
  CREATE_USER,
  GET_USERLIST,
  CREATE_TELERADIOLOGY_USER,
  COMMON_DATA_LIST,
  PACS_URL,
  AET,
  LOCAL_PACS_URL,
  LOCAL_PACS_AET,
  GET_MODALITY_WISE_PATIENT_DATA,
  GET_MONTHLY_PATIENT_DATA,
  CHANGE_REPORT_PRIORITY,
  SHARE_PATIENT_REPORT_LINK,
  GET_REFER_PHYSCIAN_INFO,
  AI_STUDY,
  UPDATE_AI_STUDY
} from '../constant';


const getToken = () => sessionStorage.getItem('token') || localStorage.getItem('token');

const requestOptions = {
  method: 'POST',
  headers: {
    Authorization: 'Bearer ' + getToken(),
    'Content-Type': 'application/json',
  },
  body: '',
};

export const filterStudies = async payload => {
  const res = await fetch(FILTER_PATIENT_STUDIES, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const getALLPatient = async (params, pgLimit = 30, pgNumber = 1) => {
  let { hospital = '', name = '', id = '', gender = '', dob = '' } = params;
  name = params['Name'] ? params['Name'] : "";
  gender = params['Gender'] ? params['Gender'] : "";
  dob = params['dob'] ? params['dob'] : "";
  return fetch(
    GET_ALL_PATIENT_API_URL +
    `?limit=${pgLimit}&offset=${pgLimit * (pgNumber - 1)}` +
    '&nameKey=' +
    name +
    '&hospitalKey=' +
    hospital +
    '&primaryIdKey=' +
    id +
    '&genderKey=' +
    gender +
    '&dateOfBirthKey=' +
    dob +
    '&accessionKey&modalitiesKey&readingDoctorNameKey&referringDoctorNameKey',
    {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
    }
  ).then(data => {
    return data.json();
  });
};

export const createNewReport = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload);
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(CREATE_REPORT, requestOptions);
  return res.json();
};

export const getCurrentReport = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload);
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(GET_CURRENT_PATIENT_REPORT, requestOptions);
  return res.json();
}

export const getReferPhysicianInfo = async (uhid: string) => {
  try {
    const requestOptions: RequestInit = {
      headers: {
        Authorization: 'Bearer ' + getToken(),
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    const response = await fetch(`${GET_REFER_PHYSCIAN_INFO}?UHID=${uhid}`, requestOptions);
    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
    }
    return response.json();
  } catch (error) {
    console.error(error, 'Error in getReferPhysicianInfo');
    throw error;
  }
};

export const getPatientDataModalityWise = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload);
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  requestOptions.method = "POST";
  let res = await fetch(GET_MODALITY_WISE_PATIENT_DATA, requestOptions);
  return res.json();
}

export const changeReportPriority = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload);
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  requestOptions.method = "POST";
  let res = await fetch(CHANGE_REPORT_PRIORITY, requestOptions);
  return res.json();
}

export const getMonthlyPatientData = async (payload: any) => {
  let response = await fetch(GET_MONTHLY_PATIENT_DATA, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
    },
    body: JSON.stringify(payload)
  });
  return response.json();
}

export const CreateNewTemplate = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload);
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(CREATE_REPORT_TEMPLATE, requestOptions);
  return res.json();
};

export const getAllReportTemplates = async (payload: any) => {
  let response = await fetch(GET_ALL_REPORT_TEMPLATES, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
    },
    body: JSON.stringify(payload)
  });
  return response.json();
};

export const sharePatientReportLink = async (payload: any) => {
  let response = await fetch(SHARE_PATIENT_REPORT_LINK, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  });
  return response.json();
};

export const deleteReportTemplate = async (payload: any) => {
  let response = await fetch(DELETE_REPORT_TEMPLATE, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
    },
    body: JSON.stringify(payload),
  });
  return response.json();
};

export const createUserApi = async payload => {
  requestOptions.body = JSON.stringify(payload);
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(CREATEUSER_API_URL, requestOptions);
  return res.json();
};

export const getALLReports = async (params, pgLimit = 30, pgNumber = 1, startDate?, endDate?) => {
  const {
    Name = '',
    modality = '',
    Age = '',
    Gender = [],
    Date = { startDate: '', endDate: '' },
    PatientId = '',
    Status = [],
    Time = '',
    UHID = '',
    diagnosis = '',
    finalImpression = '',
  } = params;
  const formattedStartDate = startDate ? String(startDate) : '';
  const formattedEndDate = endDate ? String(endDate) : '';
  const genderKey = Gender.length > 0 ? Gender.join(',') : '';
  const statusKey = Status.length > 0 ? Status.join(',') : '';
  const roleRaw = sessionStorage.getItem('role') || localStorage.getItem('role');
  const role = roleRaw === 'Government' ? 'government' : roleRaw;
  const diagnosisKey = diagnosis ? diagnosis : '';
  const finalImpressionKey = finalImpression ? finalImpression : '';

  let queryParams =
    `?limit=${pgLimit}&offset=${pgLimit * (pgNumber - 1)}` +
    `&nameKey=${Name ? Name : params?.name || ""}` +
    `&modalityKey=${modality}` +
    `&ageKey=${Age}` +
    `&genderKey=${genderKey}` +
    `&fromDate=${formattedStartDate}` +
    `&toDate=${formattedEndDate}` +
    `&timeKey=${Time}` +
    `&patientIdKey=${PatientId}` +
    `&uhidKey=${UHID}` +
    `&statusKey=${statusKey}` +
    `&impressions=${diagnosisKey}` +
    `&templateHTML=${finalImpressionKey}`;

  if (role === 'government') {
    queryParams += `&from=${role}`;
  }

  return fetch(GET_ALL_REPORTS + queryParams, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
    },
  }).then((data) => data.json());
};

export const updateReport = async payload => {
  requestOptions.body = JSON.stringify(payload)
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(UPDATE_REPORT, requestOptions)
  return res.json()
}

export const UpdateReportTemplate = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload)
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(EDIT_REPORT_TEMPLATE, requestOptions)
  return res.json()
}

export const UpdatedReportData = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload)
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(UPDATED_REPORT_DATA, {

    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)

  })
  return res.json()
}

export const addhospital = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload)
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(CREATE_HOSPITAL, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  return res.json()
}
export const updateHospitalDetail = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload)
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(UPDATE_HOSPITAL_DETAIL, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  return res.json()
}

export const GETHOSPITALLIST = async (params, pgLimit = 10, pgNumber = 1) => {
  let { search } = params;
  let url = `${HOSPITAL_LIST}?limit=${pgLimit}&offset=${pgLimit * (pgNumber - 1)}&search=${search}`
  let res = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),

    }
  })
  return res.json()
}

export const DELETEHOSPITAL = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload)
  let res = await fetch(DELETE_HOSPITAL, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  return res.json()

}

export const addUser = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload)
  let res = await fetch(CREATE_USER, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  return res.json()
}

export const GETUSERLIST = async (params, pgLimit = 10, pgNumber = 1) => {
  let { search } = params;
  const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
  let url = `${GET_USERLIST}?limit=${pgLimit}&offset=${pgLimit * (pgNumber - 1)}&search=${search}&hospitalId=${hospitalId}`
  let res = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
    }
  })
  return res.json()
}

export const GETTERAUSERLIST = async (params, pgLimit = 10, pgNumber = 1) => {
  let { search } = params;
  const teraradiologyId = sessionStorage.getItem('teraradiologyId') || localStorage.getItem('teraradiologyId');
  let url = `${GET_USERLIST}?limit=${pgLimit}&offset=${pgLimit * (pgNumber - 1)}&search=${search}&hospitalId=${teraradiologyId}&from=teraradiology`
  let res = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
    }
  })
  return res.json()
}

export const addTeleradiologyUser = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload)
  let res = await fetch(CREATE_TELERADIOLOGY_USER, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  return res.json()
}

export const COMMONDATA = async () => {

  let url = `${COMMON_DATA_LIST}`
  let res = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + getToken(),
    }
  })
  return res.json()
}

export const DELETEUSER = async (payload: any) => {
  requestOptions.body = JSON.stringify(payload)
  requestOptions.headers.Authorization = 'Bearer ' + getToken();
  let res = await fetch(DELETE_HOSPITAL, requestOptions)
  return res.json();
}

// Local PACS
export const addPatientToPacs = async (payload: any) => {
  const url = LOCAL_PACS_URL + `/dcm4chee-arc/aets/${LOCAL_PACS_AET}/rs/patients`
  const pacs_token = getLocalPACSToken();
  const headers = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${pacs_token}`
  };
  let res = await fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });
  return res;
}

// Local PACS
export const schedulePatientMwl = async (payload: any) => {
  const url = LOCAL_PACS_URL + `/dcm4chee-arc/aets/${LOCAL_PACS_AET}/rs/mwlitems`
  const pacs_token = getLocalPACSToken();
  const headers = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${pacs_token}`
  };
  let res = await fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });
  return res;
}

// Local PACS
export const checkDcmPatById = async (queryParams: any) => {
  const urlSearchParams = new URLSearchParams(queryParams).toString();

  const url = LOCAL_PACS_URL + `/dcm4chee-arc/aets/${LOCAL_PACS_AET}/rs/patients/count?${urlSearchParams}`;
  const pacs_token = getLocalPACSToken();
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${pacs_token}`
  };

  let res = await fetch(url, {
    method: 'GET',
    headers: headers,
  });
  return res;
}

//Local PACS
export const fetchSeriesData = async (payload) => {
  const urlSearchParams = new URLSearchParams(payload.queryParams).toString();

  const url = `${LOCAL_PACS_URL}/dcm4chee-arc/aets/${LOCAL_PACS_AET}/rs/studies/${payload.studyInstanceUID}/series?${urlSearchParams}`;
  const pacs_token = getLocalPACSToken();
  const headers = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${pacs_token}`
  };

  const res = await fetch(url, {
    method: 'GET',
    headers: headers,
  });

  return res;
}

// Local PACS
export const fetchMachineData = async () => {

  const url = `${LOCAL_PACS_URL}/dcm4chee-arc/aes`;
  const pacs_token = getLocalPACSToken();
  const headers = {
    'Accept': 'application/json, text/plain, */*',
    'Authorization': `Bearer ${pacs_token}`
  };

  const res = await fetch(url, {
    method: 'GET',
    headers: headers,
  });

  return res;
}

// Local PACS
export const getImagesForThumbnail = async (payload) => {
  const { studyInstanceUID, seriesInstanceUID } = payload;

  const url = `${LOCAL_PACS_URL}/dcm4chee-arc/aets/${LOCAL_PACS_AET}/rs/studies/${studyInstanceUID}/series/${seriesInstanceUID}/thumbnail`;
  const pacs_token = getLocalPACSToken();

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'image/*',
      'Accept-Encoding': 'gzip, deflate, br',
      'Accept-Language': 'en-US,en;q=0.9',
      'Connection': 'keep-alive',
      'Authorization': `Bearer ${pacs_token}`
    }
  });

  return res;
}

// Local PACS
export const sendFilesToMachine = async (payload) => {
  const { data, machineName, isSendingSeries } = payload;

  let url = [];
  if (isSendingSeries) {
    url = data?.selectedSeriesInstanceUIDs?.map(item => `${LOCAL_PACS_URL}/dcm4chee-arc/aets/${LOCAL_PACS_AET}/rs/studies/${data?.studyInstanceUID}/series/${item}/export/dicom:${machineName}`);
  }
  else {
    url = data?.selectedStudyInstanceUIDs?.map(item => `${LOCAL_PACS_URL}/dcm4chee-arc/aets/${LOCAL_PACS_AET}/rs/studies/${item}/export/dicom:${machineName}`);
  }
  const pacs_token = getLocalPACSToken();
  const requests = url.map(url => fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Accept-Encoding': 'gzip, deflate, br, zstd',
      'Accept-Language': 'en-US,en;q=0.9',
      'Connection': 'keep-alive',
      'Authorization': `Bearer ${pacs_token}`
    }
  }));
  const responses = await Promise.all(requests);

  return responses;
}

export const fetchAIData = (hospitalId: string, studyInstanceUID: string) => {
  const token = getToken();
  return axios.post(
    `${AI_STUDY}/${hospitalId}`,
    { studyInstanceUID },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  ).then(response => {
    return response.data?.result?.aiResult?.series_results || null;
  }).catch(error => {
    console.error("Error fetching AI data:", error);
    throw error;
  });
}

export const updateAIData = (hospitalId: string, studyInstanceUID: string, seriesInstanceUID: string, sopInstanceUID: string, data: object, isBoneXray: boolean = false) => {
  const token = getToken();
  return axios.post(
    UPDATE_AI_STUDY,
    { hospitalId, studyInstanceUID, seriesInstanceUID, sopInstanceUID, data, isBoneXray },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  ).then(response => {
    return response.data || null;
  }).catch(error => {
    console.error("Error updating AI data:", error);
    throw error;
  });
}
